// masonry grid control
import { msnry } from './masonry';
// hover events function
import blogPostHoverEvents from './articles-hover';
import SlimSelect from 'slim-select'

export default class LoadMore {
    constructor( initValues )
    {

        const regionsSelect = new SlimSelect({
            select: '#post-region-filter',
            placeholder: 'Filter by region',
            beforeOnChange: (info) => {
                this.beforeSelectFilterChange(info, 'regionsArrayFilter', 'regionFilterSelect')
            },
            onChange: (info) => {
                this.selectFilterHandler(info, 'regionsArrayFilter')
            },
        })

        const authorsSelect = new SlimSelect({
            select: '#post-author-filter',
            placeholder: 'Filter by author',
            beforeOnChange: (info) => {
                this.beforeSelectFilterChange(info, 'authorsArrayFilter', 'authorFilterSelect')
            },
            onChange: (info) => {
                this.selectFilterHandler(info, 'authorsArrayFilter')
            },
        })


        this.grid = document.querySelector('.archive-post-grid')
        this.filter = document.querySelectorAll('.post-type-filter a')
        this.regionFilterSelect = regionsSelect
        this.regionsArrayFilter = []
        this.authorFilterSelect = authorsSelect
        this.authorsArrayFilter = []
        this.activefilter = initValues.activeFilter ? parseInt(initValues.activeFilter) : false
        this.loadBtn = document.getElementById('js-show-more')
        this.noPostMessage = document.getElementById('js-no-posts-found')
        this.currentPage = parseInt(initValues.initial_page) + 1
        this.maxPage = parseInt(initValues.max_num_pages)
        this.post_type = initValues.post_type
        this.taxonomy = initValues.taxonomy
        this.ajax_url = initValues.ajax_url
        this.ajax_action = initValues.ajax_action
        this.dataReceived = {}
    }

    /**
     * Bootstrap out class and set event listeners
     */
    run()
    {
        this.loadBtn.addEventListener('click', this.loadMoreClickHandler.bind(this))
        // this.regionFilterSelect.addEventListener('change', this.regionFilterHandler.bind(this))
        this.filter.forEach(el => el.addEventListener('click', this.filterChanged.bind(this)))

        // set hover events on load,
        // we will need to restart this on each load more
        // for new articles
        blogPostHoverEvents()

        if ( this.currentPage > this.maxPage) {
            this.buttonVisible(false)
        }

        // set active class based on taxonomy filter
        if (this.activefilter) {
            this.filter.forEach(el => {
                el.classList.remove('active')
                if (el.dataset.termId == this.activefilter) {
                    el.classList.add('active')
                }
            })
        }
    }

  /**
   * Check new value of select and handle the logic to remove other choices if user click Global,
   * or remove Global if user click other choice
   * @param info Contain the current selected values as json object
   * @param filterName Name of the array filter to update
   * @param selectFilter Name of the select filter to update
   */
    beforeSelectFilterChange(info, filterName, selectFilter)
    {

      // see if all is selected in multi select
        let filteredResults = info.filter(entry => entry.value === 'all') ;

      // if not, simply proceed with change
        if ( !filteredResults.length > 0) {
            return true
        }

      // check if all is already active as filter
        if ( this[filterName].includes('all')) {
          // if global is active, set filter to first element after
          // basically what user has clicked
            this[selectFilter].set([info[1].value])
            return false
        } else {
          //  set filter to global and ignore other selections that were active before
            this[selectFilter].set(['all'])
            return false
        }
    }

  /**
   * Get the current active multi select values and fetch new posts
   *
   * @param info Contain the current selected values as json object
   * @param filterName Name of the array filter to update
   */
    selectFilterHandler(info, filterName)
    {
        // get only values, basically terms ids from json object
        this[filterName] = info.map(el => el.value)
        this.currentPage = 1
        this.fetchData(true)
    }


    /**
     * Handle the click on the load more post button
     */
    loadMoreClickHandler()
    {
        this.buttonVisible(false)
        this.fetchData()
    }

    /**
     * Handle the click on filter change
     *
     * @param el JS element which was clicked
     */
    filterChanged(el)
    {
        el.preventDefault()
        el.stopPropagation()

        this.activefilter = el.target.dataset.termId
        // remove active from current filter
        this.filter.forEach(el => el.classList.remove('active'))
        el.target.classList.add('active')

        this.currentPage = 1
        this.term_id = el.target.dataset.termId
        this.replaceURL(el.target.dataset.termUrl)
        this.fetchData(true)
    }

    /**
     * Change browser URL on filter change
     */
    replaceURL(url)
    {
        // This will replace the current entry in the browser's history, without reloading
        window.history.replaceState('', '', url);
    }

    /**
     * Prepare all data to be sent to server
     */
    fetchData( replaceContent = false )
    {
      // we are sending data as form data
      // so we need to make a new form object
        let formData = new FormData();
        formData.append('action', this.ajax_action);
        formData.append('post_type', this.post_type);
        formData.append('taxonomy', this.taxonomy);
        formData.append('term_id', this.activefilter);
        formData.append('regions', this.regionsArrayFilter);
        formData.append('authors', this.authorsArrayFilter);
        formData.append('paged', this.currentPage);

        fetch(this.ajax_url, {
            method: 'POST',
            body: formData,
        })
        .then(res => res.json())
        .then(data => {
            this.dataReceived = data.data
            console.log(this.dataReceived)
            if (!this.dataReceived.posts) {
                this.postVisible(true)
                this.clearGrid()
                return
            } else {
                this.postVisible(false)
            }
            replaceContent ? this.replaceContent() : this.addMorePosts()
            this.checkIfMorePosts()
        })
        .catch(err => console.log(err));

    }

    // clear masorny grid
    clearGrid()
    {
        msnry.getItemElements().forEach(e => msnry.remove(e))
        this.grid.childNodes.forEach(c => {
            if ( c.tagName && c.tagName !== 'DIV' ) {
                c.remove()
            }
          })
    }

    /**
     * This is called when we need to replace entire content of grid
     * with fresh set of articles
     */
    replaceContent()
    {
        // remove all items from masonry controller
        msnry.getItemElements().forEach(e => msnry.remove(e))

        // remove all articles inside grid but leave divs as
        // we can't remove them without reseting entire
        // masonry grid
        this.grid.childNodes.forEach(c => {
            if ( c.tagName && c.tagName !== 'DIV' ) {
                c.remove()
            }
          })

          // now we add new posts to empty grid
          this.addMorePosts()
          msnry.layout()
          blogPostHoverEvents()
    }

    /**
     * Add newly fetched posts to grid layout
     */
    addMorePosts()
    {
        const articlesNodeList = this.getNodesFromString(this.dataReceived.posts)
        articlesNodeList.forEach(el => {
          // why we are making clone ??
          // because if not the forEach will be smaller for one element
          // each time we make appendChild from it resulting in missing
          // articles at the end
            const elCopy = el.cloneNode(true);
            this.grid.appendChild(elCopy)
            msnry.appended(elCopy)
        })
        blogPostHoverEvents()
    }

    /**
     * We check if there is more articles to fetch and if not
     * we hide load more button
     */
    checkIfMorePosts()
    {
        // set max page available from data received
        this.maxPage = this.dataReceived.max_num_pages
        this.currentPage++
        if (this.currentPage > this.maxPage) {
            this.buttonVisible(false)
        } else {
            this.buttonVisible(true)
        }
    }


    buttonVisible(visible = true)
    {
        if (!visible) {
            this.loadBtn.style.display = 'none'
            return
        }
        this.loadBtn.removeAttribute('style');
    }

    //no post visible div
    postVisible(visible = true)
    {
        if (!visible) {
            this.noPostMessage.style.display = 'none'
            return
        }
        this.noPostMessage.removeAttribute('style');
    }

    getNodesFromString( stringHTML )
    {
        const postArticlesHTML = stringHTML.replace(/(\r\n|\n|\r)/gm, "")
        return new DOMParser().parseFromString(postArticlesHTML, 'text/html').body.childNodes
    }



}
